import { z } from 'zod'
import { StoreContactType, type StoreAppSettingsContact, type StoreContact } from '../../models/AppSetting'

export const StoreContactDTOSchema = z.object({
  type: z.nativeEnum(StoreContactType),
  value: z.string()
})

export type StoreContactDTO = z.infer<typeof StoreContactDTOSchema>

export const StoreAppSettingsContactDTOSchema = z.object({
  channels: z.array(StoreContactDTOSchema),
  notes: z.string().optional()
})

export type StoreAppSettingsContactDTO = z.infer<typeof StoreAppSettingsContactDTOSchema>

export function mapDTOToStoreContact (dto: StoreContactDTO): StoreContact {
  return {
    type: dto.type,
    value: dto.value
  }
}

export function mapStoreContactToDTO (model: StoreContact): StoreContactDTO {
  return {
    type: model.type,
    value: model.value
  }
}

export function mapDTOToStoreAppSettingsContact (dto: StoreAppSettingsContactDTO): StoreAppSettingsContact {
  return {
    channels: dto.channels.map(mapDTOToStoreContact),
    notes: dto.notes
  }
}

export function mapStoreAppSettingsContactToDTO (model: StoreAppSettingsContact): StoreAppSettingsContactDTO {
  return {
    channels: model.channels.map(mapStoreContactToDTO),
    notes: model.notes
  }
}
